import { forwardRef, type ComponentRef } from "react";

import { TooltipTriggerPrimitive } from "../../primitives";
import type { TooltipTriggerProps } from "./types";

/**
 * Tooltip trigger.
 *
 * Pass `asChild` to merge tooltip behavior onto a custom child element
 * (e.g. a Button). Otherwise renders a default focusable element.
 */
export const TooltipTrigger = forwardRef<
  ComponentRef<typeof TooltipTriggerPrimitive>,
  TooltipTriggerProps
>(({ asChild = false, className, children, testID, accessibilityLabel }, ref) => (
  <TooltipTriggerPrimitive
    ref={ref}
    asChild={asChild}
    className={className}
    testID={testID}
    accessibilityLabel={accessibilityLabel}
  >
    {children}
  </TooltipTriggerPrimitive>
));

TooltipTrigger.displayName = "TooltipTrigger";
